'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGrouping$002dPage$0024 from "./presto.-Edit-Grouping-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455 from "./presto.-Presto-Router$$anon$55.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$54() {
  this.bkY = null;
  this.bkQ = null;
  this.bkR = false;
  this.bkZ = null;
  this.bl0 = false;
  this.bl3 = null;
  this.bkW = null;
  this.bkX = false;
  this.bkS = null;
  this.bkT = false;
  this.bkU = null;
  this.bkV = false;
  this.bl1 = false;
  this.bl2 = false;
  this.bkY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bl3 = "EditGroupingPage";
}
export { $c_Lpresto_PrestoRouter$$anon$54 as $c_Lpresto_PrestoRouter$$anon$54 };
$p = $c_Lpresto_PrestoRouter$$anon$54.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$54;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$54() {
}
export { $h_Lpresto_PrestoRouter$$anon$54 as $h_Lpresto_PrestoRouter$$anon$54 };
$h_Lpresto_PrestoRouter$$anon$54.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bkY;
});
$p.M = (function() {
  if ((!this.bkR)) {
    this.bkQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bkR = true;
  }
  return this.bkQ;
});
$p.O = (function() {
  if ((!this.bl0)) {
    this.bkZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bl0 = true;
  }
  return this.bkZ;
});
$p.D = (function() {
  return this.bl3;
});
$p.t = (function() {
  if ((!this.bkX)) {
    this.bkW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("global", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bkX = true;
  }
  return this.bkW;
});
$p.N = (function() {
  if ((!this.bkT)) {
    this.bkS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nN(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nO(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aq, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bkT = true;
  }
  return this.bkS;
});
$p.Q = (function() {
  if ((!this.bkV)) {
    this.bkU = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455.$c_Lpresto_PrestoRouter$$anon$55();
    this.bkV = true;
  }
  return this.bkU;
});
$p.v = (function() {
  if ((!this.bl2)) {
    this.bl1 = false;
    this.bl2 = true;
  }
  return this.bl1;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee414) => ((p) => \u03b4scrutinee414.cGZ(p)))($j_presto$002e$002dEdit$002dGrouping$002dPage$0024.$m_Lpresto_EditGroupingPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$54 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$54, "presto.PrestoRouter$$anon$54", ({
  Ou: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$54 as $d_Lpresto_PrestoRouter$$anon$54 };
//# sourceMappingURL=presto.-Presto-Router$$anon$54.js.map
